

import polygon from '../../assest/ahbaab/Clean Room Consumables banner.jpg'
import { Box } from "@mui/material"
import '../../styles/ahbaab/AboutUsStyle.css'
import Footer from '../../common/ahbaab/Footer/Footer'
import Header from '../../common/ahbaab/Header/Header'




const TermsConditions = () => {

    return (
        <>
            <Header />

            <Box className='Aboutus_topdiv'>
                <img src={polygon} alt="img" />
                <div className="hosp_aboutushead">
                    <h1>Terms & Conditions</h1>
                </div>
            </Box>

            <div className=" bg-light-subtle p-5">
                <div className="">
                    <p className=" fw-bold">Terms & Conditions</p>
                    <p>The Website Owner, including subsidiaries and affiliates (“Website” or “Website Owner” or “we” or “us” or “our”) provides the information contained on the website or any of the pages comprising the website (“website”) to visitors (“visitors”) (cumulatively referred to as “you” or “your” hereinafter) subject to the terms and conditions set out in these website terms and conditions, the privacy policy and any other relevant terms and conditions, policies and notices which may be applicable to a specific section or module of the website.</p>
                </div>
            </div>


            <Footer />

        </>
    )
}

export default TermsConditions